import { render, staticRenderFns } from "./ExtraHealthVerficationModal.vue?vue&type=template&id=ef553d00&scoped=true"
import script from "./ExtraHealthVerficationModal.vue?vue&type=script&lang=js"
export * from "./ExtraHealthVerficationModal.vue?vue&type=script&lang=js"
import style0 from "./ExtraHealthVerficationModal.vue?vue&type=style&index=0&id=ef553d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef553d00",
  null
  
)

export default component.exports